interface ILocalStorage {
    creationDate?: Date | string | number;
    value: unknown;
    name: string;
}

interface ILocalStorageResponse {
    creationDate?: Date | string | number;
    value: unknown;
}

abstract class ILocalStorageService {
    public abstract checkTimeRange(checkDate: Date | string | number, name: string, timeRange: number): boolean;

    public abstract getLocalStorageValue<T>(name: string): T;

    public abstract isLocalStorageValueExist(name: string): boolean;

    public abstract setLocalStorageValue(values: ILocalStorage);

    public abstract deleteLocalStorageValue(name: string);
}

export { ILocalStorageService, ILocalStorageResponse, ILocalStorage };